var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.253 10.674a1.58 1.58 0 1 1-3.159 0 1.58 1.58 0 0 1 3.16 0Zm4.096-.123c0 3.948-5.675 9.449-5.675 9.449S7 14.499 7 10.551C7 7.434 10.059 5 12.674 5s5.675 2.434 5.675 5.551"
  })));
};
export default SvgPin;